import React from 'react';
import { CenteredContainer, DescriptionContainer, HeadingContainer, HeadingText, MainPageLinkContainer, DescriptionText, PageContainer, ButtonText, HomeButton, } from './NotFoundPage.styles';
import ErrorPageDrop from '@innovyze/stylovyze/lib/components/ErrorPage/ErrorPageDrop.svg';
import { useHistory } from 'react-router-dom';
import { useGlobalization } from '@innovyze/stylovyze/lib/contexts/GlobalizationProvider';
import { Svg } from '@innovyze/stylovyze/lib/components/Svg';
const NotFoundPage = () => {
    const history = useHistory();
    const { t } = useGlobalization();
    return (React.createElement(PageContainer, null,
        React.createElement(CenteredContainer, null,
            React.createElement(HeadingContainer, null,
                React.createElement(Svg, { svg: ErrorPageDrop, title: "error image" }),
                React.createElement(HeadingText, null, "404"),
                React.createElement(HeadingText, null, t('Page not found'))),
            React.createElement(DescriptionContainer, null,
                React.createElement(DescriptionText, null, t(`We can't seem to find the page you are looking for.
						Refresh this page, click the Home button below, or use
						the left navigation to find the page you are looking
						for.`))),
            React.createElement(MainPageLinkContainer, null,
                React.createElement(HomeButton, { variant: "outlined", color: "primary", onClick: () => history?.push('/') },
                    React.createElement(ButtonText, null, t('Home')))))));
};
export default NotFoundPage;
